module.exports = __webpack_public_path__ + "static/media/Timer 6.31a154fb.png";